import type React from "react";
import { useId } from "react";

export const RadioGroup = <T extends string>({
  options,
  onChange,
  value,
  label,
}: {
  label: string;
  value: T;
  onChange: React.Dispatch<T>;
  options: {
    value: T;
    label: string;
    isNew?: boolean;
  }[];
}) => {
  const id = useId();
  return (
    <div className="space-y-3 py-2">
      <div className="label-text px-1">{label}</div>
      <div className="grid grid-cols-2 gap-4">
        {options.map((option, index) => (
          <label key={index} className="flex items-center gap-2">
            <input
              type="radio"
              className="radio"
              name={id}
              value={option.value}
              checked={value === option.value}
              onChange={() => {
                onChange(option.value);
              }}
            />
            <span className="label-text">
              {option.label}
              {option.isNew && (
                <>
                  {" "}
                  <span className="badge badge-accent badge-sm">New</span>
                </>
              )}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};
